import React from 'react'
import { connect } from 'react-redux'
import allRoles from '../../roles/roles'
import {
    addListItem, changeListItem, deleteListItem, getListFromValues,
    hasChangedValues, getFormValue, changeItemsValue, nullDate
} from '../../public/utility'
import { doGetSalaryChangeLogInfo } from '../../reducers/actions'

class SalaryChangeLogDiv extends React.Component {
    state = {
    }

    componentDidMount = () => {
        const { dispatch, subjectName, personID } = this.props

        dispatch(doGetSalaryChangeLogInfo({
            subjectName,
            personID,
            onEnd: ({ errorMessage, initValues基本信息 }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    this.setState({ initValues基本信息, changedValues基本信息: {} })
                }
            }
        }))
    }


    handlerClose = () => {
        const { onClose } = this.props
        onClose && onClose()
    }


    canSave = () => {
        return this.bChanged()
    }

    fieldset基本信息 = () => {
        return [
            {
                _grid: '', name: '调薪明细', rowNumbers: true, minRows: 3, maxRows: 10,
                columns: [
                    { _text: '变更人', minWidth: 150, flex: 1, disabled: true },
                    { _date: '变更日期', minWidth: 150, flex: 1, disabled: true ,align: 'left'},
                    { _text: '生效月份', minWidth: 150, flex: 1, disabled: true },
                    { _text: '金额/比例', name: '金额', minWidth: 150, flex: 1, disabled: true, align: 'right' },
                ],
                buttons: [
                ],
            }]
    }

    render() {
        const { showMessage: Message, showBody: Body, bDelete } = this.props
        const { errorMessage, id, initValues基本信息, changedValues基本信息 } = this.state

        if (errorMessage) return Tyan.pubForm.showError(errorMessage)
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        return <Body data={this} maxWidth="1000"
            controls={
                [{ _button: '关闭', icon: 'close', handler: this.handlerClose }]
            }
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息(), },
                ]}
        />
    }
}

export default connect()(SalaryChangeLogDiv)